import { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import '../styles/image-carousel.css';

function ImageCarousel({ images, alt = "Image", height = "600px", objectFit = "contain" }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!images || images.length === 0) {
    return (
      <div className="image-carousel-empty" style={{ height }}>
        <p>Pas d'images disponibles</p>
      </div>
    );
  }

  const goToPrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const goToIndex = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="image-carousel" style={{ height }}>
      <div className="carousel-main">
        <img
          src={images[currentIndex].url}
          alt={`${alt} - Image ${currentIndex + 1}`}
          className="carousel-main-image"
          style={{ objectFit }}
        />

        {images.length > 1 && (
          <>
            <button className="carousel-edge carousel-edge-left" onClick={goToPrevious}>
              <ChevronLeft size={28} />
            </button>
            <button className="carousel-edge carousel-edge-right" onClick={goToNext}>
              <ChevronRight size={28} />
            </button>
            <div className="carousel-counter">
              {currentIndex + 1} / {images.length}
            </div>
          </>
        )}
      </div>

      {images.length > 1 && (
        <div className="carousel-thumbnails">
          {images.map((image, index) => (
            <button
              key={index}
              className={`carousel-thumbnail ${index === currentIndex ? 'active' : ''}`}
              onClick={() => goToIndex(index)}
            >
              <img src={image.url} alt={`${alt} - Miniature ${index + 1}`} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default ImageCarousel;
